import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IImageTile } from "@faire/web-api--source/indigofair/data/IImageTile";
import classNames from "classnames";
import React from "react";
import { SDUIOnClickHandler } from "@faire/retailer/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import * as animationStyles from "@faire/retailer/components/SDUI/__internal__/Styling/__styles__/animationStyles.css";
import { SDUIImageElementRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Image/SDUIImageElementRenderer";
import { SDUITypographyRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
import { VERTICAL_ASPECT_RATIO } from "@faire/retailer-visitor-shared/lib/verticalAspectRatio";
import { Column } from "@faire/web--source/slate/Layout";
var SQUARE_ASPECT_RATIO = 1;
var LANDSCAPE_ASPECT_RATIO = 16 / 9;
var IMAGE_TILE_WIDTH = "100%";
var DEFAULT_IMAGE_TILE_OPTIMIZE_WIDTH = 250;
export var SDUIImageTileRenderer = function(param) {
    var tileElement = param.tileElement, loggingData = param.loggingData, renderBehaviour = param.renderBehaviour;
    var _image_element_image, _image_element_image1;
    var on_click = tileElement.on_click, image_tile = tileElement.image_tile;
    if (!image_tile) {
        return null;
    }
    var style = image_tile.style, image_element = image_tile.image_element, below_image_title = image_tile.below_image_title;
    if (!image_element || !(style === null || style === void 0 ? void 0 : style.variant)) {
        return null;
    }
    var variant = style.variant, animation_on_hover = style.animation_on_hover;
    var aspectRatio = SDUIAspectRatioVariantMap[variant];
    var imageStyles = {
        aspectRatio: aspectRatio,
        width: IMAGE_TILE_WIDTH,
        height: "auto",
        isCircular: isImageCircular(variant)
    };
    var _image_element_image_width;
    var optimizeImageOptionsWidth = (_image_element_image_width = (_image_element_image = image_element.image) === null || _image_element_image === void 0 ? void 0 : _image_element_image.width) !== null && _image_element_image_width !== void 0 ? _image_element_image_width : DEFAULT_IMAGE_TILE_OPTIMIZE_WIDTH;
    var _image_element_image_height;
    var optimizeImageOptionsHeight = (_image_element_image_height = (_image_element_image1 = image_element.image) === null || _image_element_image1 === void 0 ? void 0 : _image_element_image1.height) !== null && _image_element_image_height !== void 0 ? _image_element_image_height : DEFAULT_IMAGE_TILE_OPTIMIZE_WIDTH / aspectRatio;
    var optimizeImageOptions = {
        resizeMethod: "fill",
        width: optimizeImageOptionsWidth,
        height: optimizeImageOptionsHeight
    };
    return /*#__PURE__*/ _jsx(SDUIOnClickHandler, {
        onClickActions: on_click,
        loggingData: loggingData,
        logLegacyClickEvent: true,
        children: /*#__PURE__*/ _jsxs(Column, {
            className: classNames(isImageCircular(variant) ? getCircularTileWrapperClassName(variant) : "gap-3", (animation_on_hover === null || animation_on_hover === void 0 ? void 0 : animation_on_hover.includes(IImageTile.ImageTileAnimation.UNDERLINE)) ? animationStyles.underlineAnimationHoverTarget : null, (animation_on_hover === null || animation_on_hover === void 0 ? void 0 : animation_on_hover.includes(IImageTile.ImageTileAnimation.ZOOM)) ? animationStyles.imageZoomAnimationHoverTarget : null),
            children: [
                /*#__PURE__*/ _jsx(MaybeCircleTileImageContainer, {
                    variant: variant,
                    children: /*#__PURE__*/ _jsx(SDUIImageElementRenderer, {
                        imageElement: image_element,
                        loggingData: loggingData,
                        renderBehaviour: renderBehaviour,
                        imageStyles: imageStyles,
                        optimizeImageOptions: optimizeImageOptions
                    })
                }),
                below_image_title ? /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                    textElement: below_image_title,
                    loggingData: loggingData
                }) : null
            ]
        })
    });
};
var MaybeCircleTileImageContainer = function(param) {
    var variant = param.variant, children = param.children;
    if (isImageCircular(variant)) {
        return /*#__PURE__*/ _jsx("div", {
            className: "w-[80px] md:w-[88px]",
            children: children
        });
    } else {
        return children;
    }
};
var isImageCircular = function(variant) {
    return variant === IImageTile.ImageTileVariant.CIRCLE_TILE || variant === IImageTile.ImageTileVariant.SMALL_CIRCLE_TILE;
};
var isVariantCircleTile = function(variant) {
    return variant === IImageTile.ImageTileVariant.CIRCLE_TILE;
};
var getCircularTileWrapperClassName = function(variant) {
    return isVariantCircleTile(variant) ? "items-center gap-2 w-[103.5px] md:gap-0 md:w-[112px] lg:gap-0 lg:w-[124px]" : "items-center w-full gap-3";
};
var _obj;
var SDUIAspectRatioVariantMap = (_obj = {}, _define_property(_obj, IImageTile.ImageTileVariant.IMAGE_TILE_VARIANT_UNKNOWN, SQUARE_ASPECT_RATIO), _define_property(_obj, IImageTile.ImageTileVariant.CIRCLE_TILE, SQUARE_ASPECT_RATIO), _define_property(_obj, IImageTile.ImageTileVariant.SMALL_CIRCLE_TILE, SQUARE_ASPECT_RATIO), _define_property(_obj, IImageTile.ImageTileVariant.SQUARE_TILE, SQUARE_ASPECT_RATIO), _define_property(_obj, IImageTile.ImageTileVariant.PORTRAIT_TILE, VERTICAL_ASPECT_RATIO), _define_property(_obj, IImageTile.ImageTileVariant.LANDSCAPE_TILE, LANDSCAPE_ASPECT_RATIO), _define_property(_obj, IImageTile.ImageTileVariant.LANDSCAPE_IMAGE_CUTOUT, LANDSCAPE_ASPECT_RATIO), _define_property(_obj, IImageTile.ImageTileVariant.THIN_LANDSCAPE_TILE, LANDSCAPE_ASPECT_RATIO), _obj);
